import { useSearchParams } from "react-router-dom";
import { useAuthBindVkMutation } from "../../api/main/user";
import { useEffect, useState } from "react";


function BindVk() {

  const [log, setLog] = useState(null);
  const [loading, setLoading] = useState(false);
  const [authSuccess, setAuthSuccess] = useState(false);
  const [redirect, setRedirect] = useState(null);

  const [searchParams, setSearchParams] = useSearchParams();
  const code = searchParams.get("code");
  const device_id = searchParams.get("device_id");
  const state = searchParams.get("state");

  const [authBundVkApi] = useAuthBindVkMutation();

  useEffect(() => {
    authBundVkApi({ device_id: device_id, code: code, state: state })
      .unwrap()
      .then((res) => {       
        console.log(res)
        setRedirect(res.Data.Redirect)
        if (res.Status !== 1) {
          setLog(res.Error);
          setLoading(false);
        }
        else {
            setAuthSuccess(true);         
            return window.location.replace(res.Data.Redirect);          
        }
      })
      .catch((err) => {
        setLog('Неизвестная ошибка!');
        setLoading(false);
      });
  }, []);

  return (
    <>
      <div className="row mt-5 mb-5">
        <div className="col-md-12 text-center">
          <h1>Привязка VK ID</h1>
        </div>
      </div>

      {loading === true && (
        <div className="row mt-5 mb-5">
          <div className="col-md-12 text-center log_form">
            <span className="loader_01"></span>
          </div>
        </div>
      )}
      {log !== null && (
        <div className="row mt-5 mb-5">
          <div className="col-md-12 text-center log_form">
            {log}
            <br></br>
              <a href={redirect} class="card-link">Вернуться в настройки...</a>
          </div>
        </div>
      )}
      {authSuccess === true && (
        <>
          <div className="row mt-5 mb-5">
            <div className="col-md-12 text-center text-success">
              VK ID Успешно привязан. Для возвращения нажмите: 
              <br></br>
              <a href={redirect} class="card-link">Вернуться в настройки...</a>
            </div>
          </div>          
        </>
      )}
    </>
  );
}

export default BindVk;
